<div class="editor-wrapper">
  <input
    #editorInput
    type="text"
    [matAutocomplete]="auto"
    [(ngModel)]="searchText"
    (ngModelChange)="onSearchChange($event)"
    (keydown.escape)="onEscape()"
    (keydown.enter)="onEnterKey($event)"
  />
  @if (loading) {
    <mat-spinner class="spinner" [diameter]="16"></mat-spinner>
  }
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event)"
    [displayWith]="displayFn"
    [autoActiveFirstOption]="true"
  >
    @for (option of options; track option.rid || option.name) {
      <mat-option [value]="option">
        <span class="option-name">{{ option.display_value || option.name || option.title || option.value }}</span>
      </mat-option>
    }
  </mat-autocomplete>
</div>
